<template>
  <el-scrollbar :style="{ height: listHeight }">
    <div class="grid-container">
      <div
        class="grid-content"
        v-for="item in authNodeData"
        :hidden="item.visible === 0"
        :key="item.id"
      >
        <el-row>
          <div class="grid-title">{{ languages.lan === 'cn' ? item.cname : item.ename }}</div>
          <el-col :span="3" v-for="itm in item.children" :key="itm.id">
            <div
              class="grid-item"
              v-bind:class="[
                socketStatus[0].readyState !== 1 ? 'grid-disable' : '',
                socketStatus[1].readyState !== 1 ? 'grid-disable' : '',
                socketStatus[2].readyState !== 1 ? 'grid-disable' : '',
                socketStatus[3].readyState !== 1 ? 'grid-disable' : '',
                activeTool !== itm.method && toolRunning ? 'grid-disable' : '',
                upgradeChecking ? 'grid-disable' : '',
                UacStatus === 'ON' || modelError ? 'grid-disable' : '',
                itm.method === 'developer_space' && !isT && !isTestUser ? 'hide-grid' : '',
                itm.visible === 0 || (itm.ename === 'Disk Wipe' && !showDiskWipe)
                  ? 'hide-grid'
                  : '',
                  itm.visible === 0
                  || (itm.method === 'system_recovery' && userInfo.countryEName !== 'China')
                  ? 'hide-grid' : '',
              ]"
            >
              <i
                class="el-icon-loading tool-loading"
                v-if="itm.openType === 1 && activeTool === itm.method && toolRunning"
              ></i>
              <el-tooltip :content="languages.unlockTool" effect="light" placement="bottom">
                <div class="tool-close">
                  <img
                    @click="unlockTool"
                    v-if="
                      itm.openType === 1 &&
                      activeTool === itm.method &&
                      toolRunning &&
                      enableToolClose
                    "
                    src="~assets/pics/close.png"
                    alt="close"
                  />
                </div>
              </el-tooltip>
              <el-badge
                :value="upgradeSoftCount"
                v-if="itm.ename === 'Upgrade' && itm.visible === 1 && upgradeSoftCount > 0"
                class="grid-badge"
              >
              </el-badge>
              <el-badge
                :value="deployCount"
                v-if="itm.ename === 'Program Push' && itm.visible === 1 && deployCount > 0"
                class="grid-badge"
              >
              </el-badge>
              <el-badge
                :value="fixCount"
                v-if="itm.ename === 'Patch Update' && itm.visible === 1 && fixCount > 0"
                class="grid-badge"
              >
              </el-badge>
              <img
                class="item-icon"
                :src="itm.icon"
                :hidden="itm.ename === 'TEST'"
                @click="gridClick(itm)"
                alt=""
              />
              <div class="item-title" :hidden="itm.ename === 'TEST'">
                {{ languages.lan === 'cn' ? itm.cname : itm.ename }}
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-input
        class="debug-input"
        v-if="debugMode && debugData != ''"
        :value="debugData"
      ></el-input>
      <info-message
        :languages="languages"
        :type="infoType"
        :confirm="infoConfirm"
        :show="dialogInfoVisible"
        :tips="infoTips"
      ></info-message>
      <auth-dialog
        :languages="languages"
        :type="confirmType"
        :show="dialogConfirmVisible"
        :apply="applyContent"
        :submitting="submitting"
      ></auth-dialog>
      <auto-admin-dialog
        :languages="languages.autoAddAdmin"
        :type="infoType"
        :show="dialogAutoAdminVisible"
      >
      </auto-admin-dialog>
      <account-dialog :language="languages.lan" :show="dialogAccountVisible"></account-dialog>
      <has-admin-dialog :language="languages" :show="dialogHasAdminVisible"></has-admin-dialog>
      <admin-apply-dialog
        :language="languages"
        :device="deviceName"
        :userinfo="userInfo"
        :currentUser="currentUser"
        :show="dialogAdminApplyVisible"
      ></admin-apply-dialog>
      <!-- <web-check-dialog
        :show="webDialogVisible"
        :socketData="homeData"
        :lan="languages.lan"
        :networks="networkDetails"
        from="HomeGrid"
        :lanpack="languages.homeCheck"
      ></web-check-dialog> -->
      <network-check-dialog
        :show="webDialogVisible"
        :socketData="homeData"
        :lan="languages.lan"
        :networks="networkDetails"
        from="HomeGrid"
        :lanpack="languages.NetWorkCheck"
      ></network-check-dialog>
    </div>
  </el-scrollbar>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import { Loading } from 'element-ui';
import InfoMessage from 'components/dialogs/InfoMessage.vue';
import AutoAdminDialog from 'components/dialogs/AutoAdminDialog.vue';
import HasAdminDialog from 'components/dialogs/HasAdminDialog.vue';
import AdminApplyDialog from 'components/dialogs/AdminApplyDialog.vue';
import AuthDialog from 'components/dialogs/AuthDialog.vue';
import AccountDialog from 'components/dialogs/AccountDialog.vue';
// import WebCheckDialog from 'components/dialogs/WebCheckDialog.vue';
import socket from 'common/socket';
import tools from 'common/tools';
import { ubtRegister, ubtSendTrace } from 'utils/ubt';
import UBT, { UBT_TYPE } from '@ctrip/ubt-web';
import NetworkCheckDialog from '../components/dialogs/NetworkCheckDialog.vue';

export default {
  inject: ['homeTemplate'],
  data() {
    return {
      infoType: 'warn',
      routeCommand: '',
      infoConfirm: false,
      dialogInfoVisible: false,
      dialogAutoAdminVisible: false,
      dialogConfirmVisible: false,
      dialogAccountVisible: false,
      dialogHasAdminVisible: false,
      dialogAdminApplyVisible: false,
      homeData: {},
      infoTips: {},
      confirmType: '',
      applyContent: {},
      applyCommand: {},
      submitting: false,
      toolRunning: false,
      listHeight: 0,
      activeTool: '',
      enableToolClose: false,
      networkDetails: '',
      pvId: '',
      loading: '',
    };
  },
  provide() {
    return {
      gridTemplate: this,
    };
  },
  computed: {
    ...mapState([
      'debugMode',
      'debugData',
      'languages',
      'errorTips',
      'userInfo',
      'currentUser',
      'authNodeData',
      'deviceName',
      'upgradeSoftCount',
      'upgradeIsReady',
      'deployCount',
      'fixCount',
      'toolList',
      'testTypeId',
      'isT',
      'notS',
      'isSeven',
      'showDiskWipe',
      'isAdministrator',
      'isTestUser',
      'isLaptopUser',
      'socketStatus',
      'isNewService',
      'UacStatus',
      'upgradeChecking',
      'mockMode',
      'modelError',
      'webDialogVisible',
      'localDomain',
      'applyAdminPermission',
    ]),
  },
  components: {
    InfoMessage,
    AuthDialog,
    AutoAdminDialog,
    AccountDialog,
    // WebCheckDialog,
    NetworkCheckDialog,
    HasAdminDialog,
    AdminApplyDialog,
  },
  methods: {
    ...mapMutations([
      'setWarnTips',
      'setPageNow',
      'setGridName',
      'setErrorTips',
      'setShowFooter',
      'setFooterTips',
      'setFooterWarn',
      'setErrorType',
      'setDebugInfos',
      'setSoftTabPage',
      'setSoftSearch',
      'setRedirectMode',
      'setWebDialogVisible',
      'setPvId',
      'setBatteryRedirectFlag',
    ]),
    ...mapActions([
      'getCheckInfo',
      'softwareInstall',
      'saveLog',
      'getPcDeployedTask',
      'getInternetAuth',
      'getRecommendSoftware',
      'syncSelfHelp',
    ]),
    async unlockTool() {
      const scriptName = tools.getToolName(this.activeTool);
      await socket.sendSocket(3, '(process_info)', async (res) => {
        if (res.indexOf(scriptName) > -1) {
          this.$message.warning(this.languages.toolRunning);
        } else {
          this.toolRunning = false;
          this.enableToolClose = false;
        }
      });
    },
    async gridClick(data) {
      if (
        this.socketStatus[0].readyState !== 1 ||
        this.UacStatus === 'ON' ||
        this.modelError ||
        this.upgradeChecking
      ) {
        return;
      }
      if (this.toolRunning) {
        this.$message.warning(
          data.method === this.activeTool
            ? this.languages.toolLoading
            : this.languages.otherToolRunning,
        );
        return;
      }
      this.activeTool = data.method;
      this.setGridName(data.ename); // for Program Push/Program Update
      const { visible, route, method } = data;
      console.log(`route: ${route}`, `method: ${method}`, `toolrunning: ${this.toolRunning}`);
      // gray mode, not alowed.
      if (visible === 0) return;

      if (route !== '') {
        const routerList = this.$router.options.routes[0].children;
        const fitRouter = routerList.filter((item) => item.path.indexOf(`/${route}`) !== -1);
        if (fitRouter.length === 1) {
          this.saveLog({
            title: 'grid_open',
            target: 'gridClick',
            description: route,
            reserve1: `HomeGrid > gridClick > ${data.cname}`,
            reserve2: data.id,
          });
          // trackMetric(data.ename, this.userInfo.empcode);
          // tracePageid(data.ename);
          this.$router.push(fitRouter[0].path);
          return;
        }
        this.$message.warning(`${this.languages.toolRunFail}(Length<>1)`);
        return;
      }
      if (method !== '') {
        switch (method) {
          case 'add_admin':
            this.handleApply(method);
            ubtSendTrace(245277, 'audit_pc', 'click', '', '', 'selfhelp', this.pvId);
            break;
          case 'add_host':
            this.handleApply(method);
            ubtSendTrace(245277, 'audit_host', 'click', '', '', 'selfhelp', this.pvId);
            break;
          case 'add_remote':
            this.handleApply(method);
            ubtSendTrace(245277, 'audit_remote', 'click', '', '', 'selfhelp', this.pvId);
            break;
          case 'open_account':
            this.dialogAccountVisible = true;
            ubtRegister('Account');
            break;
          case 'open_webcheck':
            this.openWebchekDialog();
            break;
          case 'developer_space':
            if (!this.isT) return;
            // if is Local Admin, run tool
            if (this.isAdministrator) {
              this.runUserTool(method);
              return;
            }
            this.toolRunning = true;
            // if not local admin
            if (!this.isAdministrator) {
              const account = this.userInfo.username;
              const result = await this.getCheckInfo(`add_admin/${account}/${this.deviceName}`);
              if (!result || result.status === 'failed') {
                this.setErrorTips(
                  `HomeGrid > Open Devloper Space > getCheckInfo > api_error: ${JSON.stringify(
                    result,
                  )}`,
                );
                this.saveLog({
                  title: 'api_error',
                  target: 'getCheckInfo',
                  description: 'get CheckInfo failed',
                  reserve1: 'HomeGrid >  Open Developer Space > getCheckInfo',
                });
                this.toolRunning = false;
                return;
              }
              const { isCurrentKey } = result.data;
              if (!isCurrentKey) {
                this.saveLog({
                  title: 'add_admin',
                  target: 'auth_apply',
                  description: 'failed',
                  reserve1: 'DeveloperSpace auto add admin',
                  reserver2: 'Not Current Pc',
                });
                this.toolRunning = false;
                this.infoType = 'warn';
                this.dialogAutoAdminVisible = true;
                UBT.send(
                  {
                    type: UBT_TYPE.EXPOSURE,
                    key: 245821,
                    data: {
                      name: data.ename,
                      empCode: this.userInfo.empcode,
                    },
                  },
                  this.pvId,
                );
                ubtRegister(data.ename);
                return;
              }
              const applyCommand = {
                userName: account,
                checkCode: result.data.checkCode,
                type: 'add_admin',
              };
              const command = JSON.stringify(applyCommand);
              if (this.isNewService) {
                await socket.sendSocket(3, `(${command})`, async (rt) => {
                  const res = JSON.parse(rt);
                  if (res.result === 'failed') {
                    this.saveLog({
                      title: 'command_error',
                      target: 'auth_apply',
                      description: 'failed',
                      reserve1: 'HomeGrid > DeveloperSpace auto add admin',
                      reserve2: res.error,
                    });
                  } else {
                    this.saveLog({
                      title: 'add_admin',
                      target: 'auth_apply',
                      description: 'success',
                      reserve1: 'HomeGrid > DeveloperSpace auto add admin',
                    });
                    this.infoType = 'info';
                    this.dialogAutoAdminVisible = true;
                  }
                });
              } else {
                socket.sendSocket(0, `idesk_apply(${command})`, (rst) => {
                  if (rst.result === 'add_admin success') {
                    this.saveLog({
                      title: 'add_admin',
                      target: 'auth_apply',
                      description: 'success',
                      reserve1: 'HomeGrid > DeveloperSpace auto add admin',
                    });
                    this.infoType = 'info';
                    this.dialogAutoAdminVisible = true;
                  } else {
                    this.saveLog({
                      title: 'add_admin',
                      target: 'auth_apply',
                      description: 'failed',
                      reserve1: 'DeveloperSpace auto add admin',
                      reserve2: rst.result,
                    });
                  }
                });
              }
            }
            this.toolRunning = false;
            break;
          default:
            this.runUserTool(method);
            break;
        }
        this.saveLog({
          title: 'grid_open',
          target: 'gridClick',
          description: method,
          reserve1: `HomeGrid > gridClick > ${data.cname}`,
          reserve2: data.id,
        });
        ubtRegister(data.ename);
        UBT.send(
          {
            type: UBT_TYPE.EXPOSURE,
            key: 245821,
            data: {
              name: data.ename,
              empCode: this.userInfo.empcode,
            },
          },
          this.pvId,
        );
      }
    },
    async openWebchekDialog() {
      const workhomeInfo = this.toolList.filter(
        (item) => item.name.indexOf('WorkHomeStatus') !== -1,
      );
      if (workhomeInfo.length !== 1) {
        this.setDebugInfos(['HomeGrid > openWebchekDialog', 'No such little tool']);
        this.setErrorTips('HomeGrid > openWebchekDialog > No such little tool');
        this.saveLog({
          title: 'api_error',
          target: 'HomeGrid > openWebchekDialog',
          description: 'No such little tool!',
        });
        return;
      }
      const res = await this.softwareInstall({
        account: this.userInfo.username,
        softwareId: workhomeInfo[0].id,
        pcName: this.deviceName,
      });
      if (res.status === 'failed') {
        this.setDebugInfos(['HomeGrid > openWebchekDialog', res.data]);
        this.setErrorTips(`HomeGrid > openWebchekDialog > ${res.data}`);
        this.saveLog({
          title: 'api_error',
          target: 'HomeGrid > openWebchekDialog > softwareInstall',
          description: res.data,
        });
        return;
      }
      const workhomeData = {
        lan: 'tools',
        type: 'silent',
        username: this.userInfo.username,
        softid: workhomeInfo[0].id,
        path: res.data.encryptPath,
        key: res.data.key,
      };
      this.homeData = workhomeData;

      const socketDatas = tools.toUnicode(JSON.stringify(workhomeData));
      this.homeTemplate.downToolNew('WorkHomeStatus', workhomeInfo[0].id, res, (cb) => {
        if (cb === 'Down Failed') {
          this.saveLog({
            title: 'command_error',
            target: 'runTool',
            description: 'Down Failed',
            reserve1: 'HomeGrid > download WorkHomeStatus',
          });
          this.$message.warning(this.languages.toolDownFail);
          return;
        }
        const runCmd = `({"level":"user", "method":"tool_run", "data":"${socketDatas}"})`;
        socket.sendSocket(2, runCmd, (rt) => {
          console.log('get networks =====>', rt);
          const rst = JSON.parse(rt);
          if (rst.result === 'failed') {
            this.setErrorTips(`HomeGrid > toolrun > ${rst.error}`);
            this.saveLog({
              title: 'command_error',
              target: 'runTool',
              description: rst.error,
              reserve1: 'HomeGrid > toolrun',
            });
            this.$message.warning(this.languages.toolDownFail);
            return;
          }
          if (rst.data === 'Tool Exited') {
            this.networkDetails = JSON.parse(rst.info).networks;
            this.setWebDialogVisible(true);
          }
        });
      });
    },
    hideAccountDialog() {
      this.dialogAccountVisible = false;
    },
    hideHasAdminDialog() {
      this.dialogHasAdminVisible = false;
    },
    hideAdminApplyDialog() {
      this.dialogAdminApplyVisible = false;
    },
    async runUserTool(method, runType) {
      setTimeout(() => {
        this.enableToolClose = true;
      }, 3000);
      const scriptName = tools.getToolName(method);
      console.log('scriptName', scriptName);
      if (this.toolRunning) {
        this.$message.warning(this.languages.toolLoading);
        return;
      }
      this.toolRunning = true;
      this.toolInfo = this.toolList.filter((item) => item.name.indexOf(scriptName) !== -1);
      if (this.toolInfo.length !== 1) {
        this.$message.warning(this.languages.toolNotFound);
        this.setErrorTips(`HomeGrid > ${scriptName} > getToolInfo > No such little tool`);
        this.saveLog({
          title: 'api_error',
          target: 'HomeGrid > getToolInfo',
          description: 'No such little tool!',
          reserve1: `toolList Length = ${this.toolInfo.length}`,
        });
        this.toolRunning = false;
        return;
      }
      // if (this.toolRunning) return;

      // local tool check
      const res = await this.softwareInstall({
        account: this.userInfo.username,
        softwareId: this.toolInfo[0].id,
        pcName: this.deviceName,
      });
      if (res.status === 'failed') {
        this.setErrorTips(`${scriptName} > softwareInstall > ${res.data}`);
        this.saveLog({
          title: 'api_error',
          lan: this.languages.lan,
          target: `${scriptName} > softwareInstall`,
          description: res.data,
        });
        this.toolRunning = false;
        this.setErrorType('apierror');
        this.$router.push('/error');
        return;
      }
      this.encryptPath = res.data.encryptPath;
      this.toolKey = res.data.key;
      const toolData = {
        lan: 'tools',
        type: 'littletools',
        username: this.userInfo.username,
        softid: this.toolInfo[0].id,
        path: this.encryptPath,
        key: this.toolKey,
      };
      const socketDatas = tools.toUnicode(JSON.stringify(toolData));
      const downCommand = `({"level":"user", "method":"tool_download", "data":"${socketDatas}"})`;
      socket.sendSocket(2, downCommand, async (ds) => {
        const dRes = JSON.parse(ds);
        console.log('down', dRes);
        if (dRes.result === 'failed') {
          this.saveLog({
            title: 'command_error',
            target: 'runUserToolNew',
            description: dRes.error,
            reserve1: 'HomeGrid > Download Little Tool',
          });
          const { downBlock, blockTips } = this.languages;
          const error = dRes.error.toLowerCase();
          if (error.indexOf(downBlock) > -1) {
            this.$message.warning({ message: blockTips, duration: 0, showClose: true });
          } else {
            this.$message.warning(this.languages.toolDownFail);
          }
          this.toolRunning = false;
          this.setErrorTips(`HomeGrid > Download Little Tool > ${dRes.error}`);
          return;
        }
        if (dRes.data === 'File Exist' || dRes.data === 'Download Finished') {
          if (dRes.data === 'Download Finished') {
            this.saveLog({
              title: 'tooldown_success',
              target: 'runUserToolNew',
              description: 'tool download success',
              reserve1: 'HomeGrid > runUserToolNew',
              reserve2: scriptName,
              reserve3: dRes.info,
            });
          }

          if (!this.isAdministrator && runType !== 'silent') {
            this.homeTemplate.initSoftModel('adf');
            await tools.sleep(3000);
          }
          const runArgs = `${scriptName}@${this.userInfo.username}`;
          let level = this.isAdministrator ? 'user' : 'adf';
          if (scriptName === 'DataTransfer' || scriptName === 'AutoJoinDomain') level = 'user';
          const rdatas = {
            lan: this.languages.lan,
            type: runArgs,
            username: this.userInfo.username,
            softid: this.toolInfo[0].id,
            path: this.encryptPath,
            key: this.toolKey,
          };
          console.log('adf 命令', rdatas);
          const runDatas = tools.toUnicode(JSON.stringify(rdatas));
          const runCommand = `({"level":"${level}", "method":"tool_run", "data":"${runDatas}"})`;
          if (!this.isAdministrator) await tools.sleep(3000);
          socket.sendSocket(2, runCommand, (rs) => {
            const rRes = JSON.parse(rs);
            console.log('tool_run', rRes);
            if (rRes.result === 'failed') {
              this.saveLog({
                title: 'command_error',
                target: 'runUserToolNew',
                description: rRes.error,
                reserve1: 'HomeGrid > runUserToolNew > Run Little Tool',
                reserve2: scriptName,
              });
              this.setErrorTips(`HomeGrid > Run Little Tool > ${rRes.error}`);
              if (rRes.error.includes('Wrong Hash')) {
                this.$message.warning(this.languages.toolHashError);
              } else {
                this.$message.warning(this.languages.toolRunFail);
              }
              if (!this.isAdministrator) this.homeTemplate.initSoftModel('ads');
              this.toolRunning = false;
              return;
            }
            if (rRes.data === 'Tool Start') {
              this.saveLog({
                title: 'toolrun_success',
                target: 'runUserToolNew',
                description: 'tool run success',
                reserve1: 'HomeGrid > runUserToolNew > Run Little Tool',
                reserve2: scriptName,
                reserve3: runType === 'silent' ? 'silent' : runArgs,
              });
            }
            if (rRes.data === 'Tool Running') {
              this.$message.warning(this.languages.toolLoading);
            }
            if (rRes.data === 'Tool Exited') {
              if (this.isAdministrator) {
                this.enableToolClose = false;
                this.toolRunning = false;
                this.activeTool = '';
                return;
              }
              this.homeTemplate.initSoftModel('ads');
              setTimeout(() => {
                this.enableToolClose = false;
                this.toolRunning = false;
                this.activeTool = '';
              }, 2000);
            }
          });
        }
      });
    },
    async handleApply(type) {
      const account = this.userInfo.username;
      const result = await this.getCheckInfo(`${type}/${account}/${this.deviceName}`);
      if (result.status === 'failed') {
        this.showInfoDialog(
          'warn',
          this.languages.permission.auth,
          this.languages.permission.tryAgain,
          type,
          'failed > getCheckInfo apierror',
          true,
        );
      } else {
        if (result.data.isCurrentKey === false) {
          this.showInfoDialog(
            'warn',
            this.languages.softInstall.authNote,
            this.languages.maxNumber,
            type,
            'failed > NotCurrentUser',
            true,
          );
          return;
        }
        this.confirmType = 'info';
        let applyName = '';
        switch (type) {
          case 'add_admin':
            if (this.isAdministrator) {
              this.dialogHasAdminVisible = true;
              return;
            }
            if (!this.applyAdminPermission) {
              this.dialogAdminApplyVisible = true;
              return;
            }
            applyName = this.languages.permission.admin;
            break;
          case 'add_host':
            applyName = this.languages.permission.host;
            break;
          case 'add_remote':
            applyName = this.languages.permission.remote;
            break;
          default:
            break;
        }
        this.applyContent = {
          applyName,
          pcName: this.deviceName,
          userName: account,
        };
        this.applyCommand = {
          userName: account,
          checkCode: result.data.checkCode,
          type,
        };
        this.dialogConfirmVisible = true;
      }
    },
    showInfoDialog(type, note, info, title, description, toLog) {
      this.infoType = type;
      this.infoTips = { title: note, info };
      this.dialogInfoVisible = true;
      if (toLog) {
        this.saveLog({
          title,
          target: 'auth_apply',
          description,
          reserve1: 'HomeGrid > showInfoDialog',
        });
      }
    },
    hideInfoDialog() {
      this.dialogInfoVisible = false;
    },
    hideAutoAdminDialog() {
      this.dialogAutoAdminVisible = false;
    },
    cancelApply() {
      this.dialogConfirmVisible = false;
      this.submitting = false;
      this.applyContent = {};
      this.applyCommand = {};
    },
    async submitApply() {
      this.submitting = true;
      const command = JSON.stringify(this.applyCommand);
      const { type } = this.applyCommand;
      let messageInfo = '';
      switch (type) {
        case 'add_admin':
          messageInfo = this.languages.permission.admin;
          break;
        case 'add_host':
          messageInfo = this.languages.permission.host;
          break;
        case 'add_remote':
          messageInfo = this.languages.permission.remote;
          break;
        default:
          break;
      }
      this.loading = Loading.service({
        target: '.system-container',
        text: this.languages.permission.loading,
        background: 'rgba(0, 0, 0, 0.7)',
      });
      await socket.sendSocket(3, `(${command})`, async (rt) => {
        const res = JSON.parse(rt);
        this.saveLog({
          title: 'AuthApply',
          target: type,
          description: 'Auth Apply Result',
          reserve1: 'HomeGrid > submitApply',
          reserve2: rt,
        });
        this.loading.close();
        if (res.result === 'failed') {
          this.setErrorTips(`HomeGrid > ${type} > ${res.error}`);
          this.showInfoDialog(
            'warn',
            this.languages.softInstall.authNote,
            `【${messageInfo}】${this.languages.softInstall.addFailed}`,
            type,
            `failed > ${res.error}`,
            true,
          );
        } else {
          this.showInfoDialog(
            'info',
            this.languages.softInstall.authNote,
            `【${messageInfo}】${this.languages.softInstall.addSuccess}${
              type === 'add_admin' ? this.languages.permission.reboot : ''
            }`,
            type,
            'success',
            true,
          );
        }
      });
      this.cancelApply();
    },
    redirectMode(command) {
      let data = {
        route: command.route || '',
        method: command.method || '',
        source: command.source || '',
        qid: command.qid || '',
      };
      console.log('redirectMode data >>>', data);
      // 全链路卡片自助率埋点qid
      console.log('qid ========================', data.qid);
      if (data.qid) {
        this.syncSelfHelp(data.qid);
      }
      this.saveLog({
        title: 'redirect_mode',
        target: 'redirectMode',
        description: JSON.stringify(data),
        reserve1: 'HomeGrid > redirectMode',
      });
      // 软件搜索
      if (data.route.indexOf('SoftwareInstall') !== -1) {
        this.setRedirectMode(true);
        const params = data.route.split('@');
        if (params.length === 2) {
          data = { route: 'SoftwareInstall', method: '' };
          setTimeout(() => {
            this.setSoftSearch(params[1]);
          }, this.languages.searchDelay || 500);
        }
      }
      // 电脑状态-电池详情
      if (data.route.includes('system_info')) {
        this.setRedirectMode(true);
        const params = data.route.split('@');
        if (params.length === 2) {
          if (params[1] === 'battery') {
            this.setBatteryRedirectFlag(true);
          }
          data = { route: 'system_info', method: '' };
        }
      }
      setTimeout(() => {
        console.log(`home grid click data: ${JSON.stringify(data)}`);
        this.gridClick(data);
      }, this.languages.redirectDelay || 3000);
    },
    getGridListHeight() {
      this.listHeight = `${document.body.clientHeight - 90}px`;
      window.onresize = () => (() => {
        this.listHeight = `${document.body.clientHeight - 90}px`;
      })();
    },
    // no use for now
    // async getDeployTask() {
    //   const getTaskResult = await this.getPcDeployedTask(this.deviceName);
    //   if (getTaskResult === 'error') {
    //     this.setErrorTips('Home > getTaskResult failed');
    //     this.setDebugInfos(['HomeGrid > getPcDeployedTask', 'getTaskResult failed']);
    //     this.saveLog({
    //       title: 'api_error',
    //       target: 'getPcDeployedTask',
    //       description: 'get deploy task datas failed',
    //       reserve1: 'HomeGrid > getPcDeployedTask',
    //     });
    //   }
    // },
    isLevelLowerSeven() {
      const level = this.userInfo.emplevel;
      if (!level) return true;
      if (level.indexOf('T') > -1) {
        return level.replace('T', '') < 22;
      }
      return level < 7;
    },
    adminLevelCheck() {
      if (this.isSeven) return true;
      if (this.isT) return true;
      // 管理员权限收缩，取消此规则
      // if (this.notS && this.isLaptopUser) return true;
      return false;
    },
  },
  beforeDestroy() {
    this.$root.$off('goApply');
  },
  async created() {
    this.$root.$on('goApply', (item) => {
      this.handleApply(item);
    }); // for HomeCheck > add remote
    console.log('home_grid > urlParam >>> ', this.$route.query);
    this.getGridListHeight();
    this.setDebugInfos(['HomeGrid > urlParam', this.$route.query]);
    const { command } = this.$route.query;
    this.routeCommand = command || '';
    this.setPageNow('HomeGrid');
    this.setFooterTips('');
    this.setFooterWarn('');
    this.setShowFooter(false);

    if (!this.mockMode) {
      // user internet permission(API)
      const getInternetResult = await this.getInternetAuth();
      if (getInternetResult === 'failed') {
        this.setErrorTips(`getInternetAuth failed: ${getInternetResult.data}`);
        this.saveLog({
          title: 'api_error',
          target: 'getInternetAuth',
          description: `getInternetAuth failed: ${getInternetResult.data}`,
          reserve1: 'HomeGrid > user internet permission check',
        });
        this.setDebugInfos(['HomeGrid > getInternetAuth failed', getInternetResult.data]);
      } else {
        this.setDebugInfos(['Home > getInternetAuth success', this.internetAuth]);
      }
    }

    // get recommend software(API)
    const recommendResult = await this.getRecommendSoftware();
    if (recommendResult !== 'success') {
      this.setDebugInfos(['HomeGrid > getRecommendSoftware', 'failed']);
      this.saveLog({
        title: 'api_error',
        target: 'getRecommendSoftware',
        description: 'getRecommendSoftware failed',
        reserve1: 'HomeGrid > getRecommendSoftware',
      });
    }

    setTimeout(async () => {
      await socket.sendSocket(3, '(disk_free)', async (rt) => {
        try {
          const size = Number(
            rt.substring(rt.indexOf('":\\\\\\\\\\\\\\"') + 10, rt.indexOf('\\\\\\\\\\\\\\",')),
          );
          this.setDebugInfos(['HomeGrid > Disk C Check', size]);
          if (size && size < 2000) {
            this.setWarnTips(this.languages.diskLow);
          }
        } catch (error) {
          console.log(error);
        }
      });
    }, 3000);
    if (this.routeCommand) {
      const routeCmd = JSON.parse(this.routeCommand);
      if (routeCmd.route || routeCmd.method) this.redirectMode(routeCmd);
    }
    // this.pvId = ubtRegister('Home');
    // this.setPvId(this.pvId);
  },
};
</script>

<style lang="scss" scoped>
.debug-input {
  width: 5%;
}
.grid-container {
  margin: 20px;
  margin-bottom: 0;
  .grid-content {
    position: relative;
    margin-top: 13px;
    padding: 15px 25px 25px 25px;
    background-color: #f2f7ff;
    border-radius: 10px;
    .grid-title {
      position: absolute;
      left: -10px;
      top: -5px;
      font-size: 14px;
      font-weight: 700;
    }
    .grid-item {
      height: 80px;
      margin-top: 10px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      min-width: 130px;
      .item-icon {
        position: relative;
        top: 14px;
        width: 48px;
        height: 48px;
        cursor: pointer;
      }
      .item-icon:hover {
        transition: all 0.2s ease-in-out;
        transform: scale(1.15);
      }

      .item-title {
        position: relative;
        top: 20px;
        font-size: 12px;
        text-align: center;
      }

      .tool-loading,
      .tool-close {
        position: absolute;
        top: 4px;
        font-size: 18px;
        z-index: 2;
      }
      .tool-loading {
        left: 25px;
      }
      .tool-close {
        right: 25px;
        top: 2px;
        cursor: pointer;
        opacity: 0.5;
        img {
          width: 16px;
          height: 16px;
        }
      }

      .grid-badge {
        position: absolute;
        margin-left: 35px;
        margin-top: 5px;
        z-index: 1;
      }
    }
    .hide-grid {
      display: none;
    }
    .grid-disable {
      opacity: 0.4;
      .item-icon {
        cursor: not-allowed;
      }
    }
  }
}
</style>
